import React from 'react';
import { CircleBackground, CircleProgress, PercentageText, Wrapper } from './style';
import { colorPalette } from 'utils/styleConstants';

export interface GraphProps {
  percentage: number;
  size?: number | string;
}

const Graph = ({ percentage, size = 200 }: GraphProps) => {
  const color = colorPalette.turquoise.dark
  const strokeWidth = 6
  const radius = (50 - strokeWidth / 2);
  const circumference = (2 * Math.PI * radius);
  const offset = circumference - (percentage / 100) * circumference;

  const wrapperSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <Wrapper size={wrapperSize}>
      <svg width='100%' height='100%' viewBox='0 0 100 100'>
        <CircleBackground cx='50' cy='50' r={radius} strokeWidth={strokeWidth} />
        <CircleProgress
          cx='50'
          cy='50'
          r={radius}
          strokeWidth={strokeWidth}
          color={color}
          circumference={circumference}
          offset={offset}
        />
        <PercentageText x={50} y={50}>
          {percentage}%
        </PercentageText>
      </svg>
    </Wrapper>
  );
};

export default Graph;
